var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOutlineIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3906 14.25L9.39234 6.96477L9.40088 6.97159L13.9076 1.75H12.4015L8.73028 6L5.81484 1.75H1.86511L6.53148 8.55172L6.53092 8.55114L1.60938 14.25H3.11539L7.19698 9.52159L10.4409 14.25H14.3906ZM5.21812 2.88636L12.231 13.1136H11.0376L4.01902 2.88636H5.21812Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOutlineIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/outline-icon.d273ef1f52999be4ecbf92daf4ce6b49.svg";